import script from "./UCPreload.vue?vue&type=script&setup=true&lang=js"
export * from "./UCPreload.vue?vue&type=script&setup=true&lang=js"

import "./UCPreload.vue?vue&type=style&index=0&id=00636498&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00636498"]])

export default __exports__